module.exports = __webpack_public_path__ + "img/tab-vehicle-row-side-mitsubishi.160389a4.png";